
export class AbstractEpics {

  constructor(options) {
    /** @type {Logger} **/
    this.logger = options.logger;
    this.epics = [];
  }

  /**
   * Add custom epic to the list.
   * @param {Function} epic
   */
  addEpic(epic) {
    this.epics.push(epic);
  }

  /**
   * Add custom epics to the list.
   * @param {Array<>} epics
   */
  addEpics(epics) {
    this.epics.push(...epics);
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/redux/AbstractEpics.js